<template>
  <!-- header -->
  <div>
    <mobile-header v-if="mobile && getHeadTitle !== 'NONE'" :title="getHeadTitle" @close="backRouting" />
    <v-navigation-drawer v-if="!mobile" app dark width="256px" mini-variant-width="80px" :mini-variant.sync="getMini"
      v-model="drawer" permanent color="#524B48">
      <v-list-item class="px-3" style="height: 80px;">
        <v-btn icon @click.stop="toggleMini">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-list-item>

      <div class="sidebar-content-wrapper">
        <div class="menu-container">
          <v-list nav class="menu" expand>
            <template v-for="(menu, index) in menus">
              <v-list-group v-if="menu.items" :key="`item-${index}`" v-bind="$attrs" class="px-0" color="white">
                <template #activator>
                  <v-list-item-icon :class="{ menuImg: getMini }">
                    <v-img :src="menu.img"></v-img>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title class="menu-title" style="font-size: 16px">
                      {{ menu.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-for="(subMenu, i) in menu.items">
                  <v-list-item :key="i" class="menu-img-title__wraps" link color="white" :to="subMenu.to">
                    <v-list-item-icon :class="{ menuImg: getMini }">
                      <v-img :src="subMenu.img"></v-img>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title style="font-size: 14px" class="menu-title sub">{{ subMenu.title
                        }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>
              <v-list-item v-else :key="menu.title" class="menu-img-title__wraps" link :to="menu.to">
                <v-list-item-icon :class="{ menuImg: getMini }">
                  <v-icon color="#BEBEBE" v-if="menu.icon">{{ menu.icon }}</v-icon>
                  <v-img v-else :src="menu.img"></v-img>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size: 16px" class="menu-title">{{
                    menu.title
                    }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </div>

        <v-list-item class="help-center" :class="{ miniActive: getMini }">
          <span>고객센터 <br />
            1661-0862</span>
        </v-list-item>
      </div>
      <img class="logo-bg" :class="{ miniActive: getMini }" src="@/assets/icons/bg_logo-big.svg" alt="" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import myMixin from "@/mixin/mixin";
import { mapGetters } from "vuex";
import Meta from "@/components/common/Meta";

import TermPopup2 from "@/components/term/TermPopup2";
import "@/assets/js/jquery-1.9.1.min.js";
import MobileHeader from "../mobile/MobileHeader.vue";

export default {
  name: "Header",
  mixins: [myMixin],
  props: ["currentPath", "name"],
  data() {
    return {
      drawer: true,
      mini: false,
      model: null,
      secessionPw: "",
      displayAddFlag: false,

      type: localStorage.getItem("access_type"),
      password: "",
      agreeFlag: false,
      corpSearchTxt: ""
    };
  },
  computed: {
    ...mapGetters([
      "corpInfo",
      "directorInfo",
      "funeralInfo",
      "getMini",
      "getToggle",
      "getHeadTitle"
    ]),

    getAdminType() {
      const adminType = localStorage.getItem("access_type");
      return adminType;
    },

    userInfo() {
      return this.getAdminType === "funeral"
        ? this.funeralInfo
        : this.getAdminType === "corp"
          ? this.corpInfo
          : this.directorInfo;
    },
    menus() {
      let menu = [
        {
          title: "홈",
          img: require("@/assets/icons/master/dash-board.svg"),
          to: `/${this.getAdminType}/main`
        },
        {
          title: "부고 관리",
          img: require("@/assets/icons/master/obituary.svg"),
          items: [
            { title: "부고 리스트", to: `/${this.getAdminType}/obituary-list` },
            {
              title: "추모의 글 관리",
              to: `/${this.getAdminType}/obituary-message`
            }
          ]
        },

        {
          title: "추모영상",
          img: require("@/assets/icons/master/movie.svg"),
          to: `/${this.getAdminType}/movie`
        },

        {
          title: "위패/지방 축문",
          img: require("@/assets/icons/master/archive.svg"),
          items: [
            { title: "위패 / 지방", to: `/${this.getAdminType}/tablet1` },
            { title: "장례지도사용 축문", to: `/${this.getAdminType}/tablet2` },
            { title: "기제사 축문", to: `/${this.getAdminType}/tablet3` }
          ]
        },

        {
          title: "페이백 관리",
          img: require("@/assets/icons/master/payback.svg"),

          to: `/${this.getAdminType}/payback`
        },
        {
          title: "게시판",
          img: require("@/assets/icons/master/notice.svg"),
          to: `/notice`
        },
        {
          title: "자주쓰는 문서함",
          img: require("@/assets/icons/master/document.svg"),
          to: `/format`
        },
        {
          title: "스킨 배너 관리",
          icon: "mdi-file-image-outline",
          to: `/${this.getAdminType}/skinBanner`
        },
        // {
        //   title: "입관/빈소 설정",
        //   img: require("@/assets/icons/master/mortuary.svg"),
        //   to: `/${this.getAdminType}/enterRoom`
        // },
        {
          title: "빈소 설정",
          img: require("@/assets/icons/master/mortuary.svg"),
          to: `/${this.getAdminType}/mortuary`
        }
      ];

      if (!this.userInfo) return menu;

      if (this.getAdminType === "director") {
        menu.splice(7, 2);

        if (!this.userInfo.Corps) {
          return menu;
        }

        const findIdx =
          this.userInfo.Corps &&
          this.userInfo.Corps.findIndex(v => v.CorpDirector.applyYn === true);

        const applyCorp = this.userInfo.Corps[findIdx];

        if (applyCorp && applyCorp.Payback) {
          if (!applyCorp.Payback.personalUseYn) {
            menu.splice(4, 1);
          }

          if (!applyCorp.Payback.movieRateYn) {
            menu.splice(2, 1);
          }
        }
      } else if (this.getAdminType === "corp") {
        menu = [
          {
            title: "홈",
            img: require("@/assets/icons/master/dash-board.svg"),
            to: `/${this.getAdminType}/main`
          },
          {
            title: "장례지도사 관리",
            img: require("@/assets/icons/master/users.svg"),
            to: `/${this.getAdminType}/director-list`
          },
          {
            title: "부고 관리",
            img: require("@/assets/icons/master/obituary.svg"),
            items: [
              {
                title: "부고 리스트",
                to: `/${this.getAdminType}/obituary-list`
              },
              {
                title: "추모의 글 관리",
                to: `/${this.getAdminType}/obituary-message`
              }
            ]
          },
          {
            title: "추모영상",
            img: require("@/assets/icons/master/movie.svg"),
            to: `/${this.getAdminType}/movie`
          },

          {
            title: "스킨 배너 관리",
            icon: "mdi-file-image-outline",
            to: `/${this.getAdminType}/skinBanner`
          },

          {
            title: "페이백 관리",
            img: require("@/assets/icons/master/payback.svg"),
            items: [
              { title: "적립 내역", to: `/${this.type}/payback` },
              {
                title: "정산 신청 / 정산 내역",
                to: `/${this.type}/payback-detail`
              }
            ]
          },
          {
            title: "게시판",
            img: require("@/assets/icons/master/notice.svg"),
            to: `/notice`
          },
          {
            title: "자주쓰는 문서함",
            img: require("@/assets/icons/master/document.svg"),
            to: `/format`
          }
        ];

        if (!this.userInfo.Payback) {
          menu.splice(5, 1);
        }

        if (this.userInfo.Payback && !this.userInfo.Payback.useYn) {
          menu.splice(5, 1);
        }
        return menu;
      } else {
        if (!this.userInfo.Payback) {
          menu.splice(4, 1);
          menu.splice(2, 1);
        }

        if (this.userInfo.Payback && !this.userInfo.Payback.useYn) {
          menu.splice(4, 1);
        }

        if (this.userInfo.Payback && !this.userInfo.Payback.movieRateYn) {
          menu.splice(2, 1);
        }
      }
      return menu;
    }
  },

  components: {
    Meta,
    TermPopup2,
    MobileHeader
  },
  mounted() {
    // $document ready 처럼 생성후 실행
    // this.$store.commit("END_DEEMED");
    this.$nextTick(function () {
      this.allLoadingEvent();
    });

    this.onResize();

    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    move(path) {
      this.$router.push(path);
    },
    displayAddPopup() {
      this.displayAddFlag = !this.displayAddFlag;
      if (this.displayAddFlag) {
        this.$store.commit("START_DEEMED");
      } else {
        this.$store.commit("END_DEEMED");
      }
    },

    routingMenu(event) { },
    toggleMini() {
      this.$store.commit("toggleMini", !this.getMini);
    },

    onResize() {
      if (this.getToggle) {
        return;
      }
      if (window.innerWidth < 1264) {
        this.$store.commit("setMini", true);
      } else {
        this.$store.commit("setMini", false);
      }
    }
  }
};
</script>

<style>
#master-main .header {
  height: 80px !important;
  padding: 0px 40px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

#master-main .header .v-toolbar__content {
  width: 100%;
  justify-content: space-between;
}

#master-main .header .v-toolbar__content img {
  margin-left: 34px;
}

@media (max-width: 960px) {
  #master-main .header {
    max-height: 80px !important;
  }
}

.v-list--nav {
  padding-left: 12px;
  padding-right: 12px;
}

.v-list--nav .v-list-item,
.v-list--nav .v-list-item:before {
  border-radius: 12px;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child),
.v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 0px !important;
}

/* 사이드바 컨텐츠 래퍼 */
.sidebar-content-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
}

/* 메뉴 컨테이너 - 고정 높이, overflow 처리 */
.menu-container {
  height: calc(100vh - 80px - 150px);
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
}

.help-center {
  position: relative;
  bottom: auto;
  left: 0;
  width: 200px;
  height: 120px;
  bottom: 0px !important;
}

.help-center span {
  font-family: var(--noto3);
  font-weight: 500;
  font-size: 20px;
}

.help-center.miniActive {
  display: none;
}

.logo-bg {
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0.08;
}

.logo-bg.miniActive {
  opacity: 0;
}

.menuImg {
  margin-right: 0px !important;
}
</style>
